import { useQuery } from '@apollo/client';
import {
    GET_COMMON_CONFIG_BY_KEY,
    GetCommonConfigByKeyResponse,
    GetCommonConfigByKeyVariables,
} from '../../pages/config/common-config/graphql/commonConfigQueries';
import { DEFAULT_ARCHIVE_DAYS, ORDER_ARCHIVE_DAYS_CONFIG_KEY, parseArchiveDays } from './archiveDays';

/**
 * 读取包裹查询覆盖天数（= 归档天数）。
 * - 加载中返回 null：签收时间限制等避免用错误天数闪一下
 * - 请求失败 / 无 data：回落 DEFAULT_ARCHIVE_DAYS，保证 R4 空态引导仍能展示（与 parseArchiveDays 口径一致）
 */
export function useParcelQueryRangeDays(): number | null {
    const { data, loading, error } = useQuery<GetCommonConfigByKeyResponse, GetCommonConfigByKeyVariables>(
        GET_COMMON_CONFIG_BY_KEY,
        { variables: { configKey: ORDER_ARCHIVE_DAYS_CONFIG_KEY }, fetchPolicy: 'cache-first' }
    );
    if (loading) {
        return null;
    }
    if (error || !data) {
        return DEFAULT_ARCHIVE_DAYS;
    }
    return parseArchiveDays(data.getCommonConfigByKey);
}
